export default __webpack_public_path__ + "static/media/play.d39062d5.svg";